import * as React from "react";
import ReactDOM from "react-dom";
import { Affix } from "antd";
import BaseComponent from "src/engine/ui/BaseComponent";
import UIInject, { IHandle } from "../UIInject";
import UIManifest from "src/engine/ui/UIManifest";
import IUIItem from "src/engine/interface/IUIItem";
import ArrayFind from "./ArrayFind";
import AutoConfig from "src/engine/decorator/AutoConfig";
import AutoContext from "src/engine/decorator/AutoContext";
import PageContext, { IPageContext } from "src/engine/pages/ui/PageContext";
import Utils from "src/lib/utils/Utils";

interface IAntAffix {
    uiItem: IUIItem;
    attachPage: boolean;
    targetString?: string;
}

interface IState {
    status: boolean;
}

ArrayFind();

@UIManifest.declareGG(["ggValue", "dataValue"], "AntAffix", "AntAffix固钉", UIManifest.Type.AntD)
class AntAffix extends BaseComponent<IAntAffix, IState> {
    state = { status: false };
    box: any;
    onChange = (status: boolean) => {
        this.setState({ status });
        console.log(status);
        if ((window as any).CMSConst?.maps?.isEdit) {
            if (status) {
                const box: any = ReactDOM.findDOMNode(this.box);
                setTimeout(() => {
                    const fixed = box.querySelector(".ant-affix");
                    if (fixed) fixed.style.top = "0";
                }, 1);
            }
        }
    };

    pageContext: IPageContext;

    @AutoContext(PageContext, "pageContext")
    renderPage() {
        const { attachPage, ...props } = this.props;
        // const ref = this.pageContext.pageRef();
        (props as any).target = this.pageContext.pageRef;
        return this.renderUI(props);
    }

    getProps(props: any) {
        const { targetString, attachPage, ...other } = props;
        if (targetString) {
            return { ...other, target: () => document.querySelector(targetString) };
        } else {
            return other;
        }
    }

    renderUI(props: any = {}) {
        const handles: IHandle[] = [{ type: "ui", key: "children", uiKey: "children" }];
        return <UIInject ui={Affix} ref={Utils.ref(this, "box")} {...this.getProps(props)} handles={handles} onChange={this.onChange} />;
    }

    @AutoConfig.Provider(["state.status,status"])
    render() {
        const { attachPage = false, ...props } = this.props;

        if (attachPage) {
            return this.renderPage();
        } else {
            return this.renderUI(props);
        }
        // const handles: IHandle[] = [{ type: "ui", key: "children", uiKey: "children" }];
        // if(attachPage){

        // }

        // return <UIInject ui={Affix} {...this.props} handles={handles} onChange={this.onChange} />;
    }
}

export default AntAffix;
